( function () {

	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	const initializeBlock = function( $block ) {

		var block = $block[0];
		var tabSet = block.querySelector('.js-tabbed-content');

		if ( tabSet ) {
			setupTabs( tabSet );
		}

	};


  /**
   *
   *
   */
	const setupTabs = function( tabSet ) {

    // Get relevant elements and collections
    const tabsetID = tabSet.getAttribute('id');
    const tablist = tabSet.querySelector('ul');
    if ( tablist === null ) return;

    const tabs = tablist.querySelectorAll('a');
    if ( tabs === null || tabs.length < 1 ) return;

    const panels = tabSet.querySelectorAll('[id^="section"]');
    if ( panels === null ) return;

    // The tab switching function
    const switchTab = (oldTab, newTab) => {
      
      newTab.focus();

      // Make the active tab focusable by the user (Tab key)
      newTab.removeAttribute('tabindex');

      // Set the selected state
      newTab.setAttribute('aria-selected', 'true');
      oldTab.removeAttribute('aria-selected');
      oldTab.setAttribute('tabindex', '-1');
      
      // Get the indices of the new and old tabs to find the correct
      // tab panels to show and hide
      const index = Array.prototype.indexOf.call(tabs, newTab);
      const oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
      
      panels[oldIndex].hidden = true;
      panels[index].classList.remove('do-transition');
      panels[index].hidden = false;

      setTimeout( () => {
        panels[index].classList.add('do-transition');
      }, 50 );
      
    }
    
    // Add the tablist role to the first <ul> in the .tabbed container
    tablist.setAttribute('role', 'tablist');
    
    // Add semantics are remove user focusability for each tab
    Array.prototype.forEach.call(tabs, (tab, i) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('id', tabsetID + '_tab_' + (i + 1));
      tab.setAttribute('tabindex', '-1');
      tab.parentNode.setAttribute('role', 'presentation');
      
      // Handle clicking of tabs for mouse users
      tab.addEventListener('click', e => {
        e.preventDefault();

        const currentTab = tablist.querySelector('[aria-selected]');
        
        if (e.currentTarget !== currentTab) {
          switchTab(currentTab, e.currentTarget);
        }
        
      });
      
      // Handle keydown events for keyboard users
      tab.addEventListener('keydown', e => {

        // Get the index of the current tab in the tabs node list
        const index = Array.prototype.indexOf.call(tabs, e.currentTarget);

        // Work out which key the user is pressing and
        // Calculate the new tab's index where appropriate
        const dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;

        if (dir !== null) {
          e.preventDefault();

          // If the down key is pressed, move focus to the open panel,
          // otherwise switch to the adjacent tab
          dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
        }
      });

    });
    
    // Add tab panel semantics and hide them all
    Array.prototype.forEach.call(panels, (panel, i) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '-1');
      // let id = panel.getAttribute('id');
      panel.setAttribute('aria-labelledby', tabs[i].id);
      panel.hidden = true; 
    });
    
    // Initially activate the first tab and reveal the first tab panel
    tabs[0].removeAttribute('tabindex');
    tabs[0].setAttribute('aria-selected', 'true');
    panels[0].classList.add('do-transition');
    panels[0].hidden = false;

	};


	/**
	 *
	 *
	 */
	if ( !document.body.classList.contains('wp-admin') ) {

		const tabSets = document.querySelectorAll('.js-tabbed-content');
		
    tabSets.forEach( tabSet => {
			setupTabs( tabSet );
		});

	}


	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=tabbed-content', initializeBlock);
	}

} )();